import React, {ReactNode} from 'react'
import {Card as AntdCard, CardProps} from 'antd'
import clsx from 'clsx'
import {WithChildren} from '_metronic/helpers'

type Props = {
  props?: any
  title?: string | ReactNode

  className?: string | undefined
  cardProps?: CardProps
  children?: React.ReactNode | undefined
}

const Card: React.FC<Props & WithChildren> = (props) => {
  const {title, className, cardProps} = props
  return (
    <AntdCard
      size={cardProps?.size}
      className={clsx('rounded-0', className)}
      title={
        title ? (
          <span className='fs-3 fw-bold' style={{letterSpacing: -0.5}}>
            {title}
          </span>
        ) : undefined
      }
      {...cardProps}
    >
      {props.children}
    </AntdCard>
  )
}

export {Card}
